var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifebelt16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1a7 7 0 110 14A7 7 0 018 1zM4.839 9.504l-1.837 1.34a5.778 5.778 0 002.154 2.154l1.341-1.836a3.514 3.514 0 01-1.658-1.658zm4.665 1.657l1.34 1.837a5.778 5.778 0 002.154-2.154l-1.837-1.34a3.514 3.514 0 01-1.657 1.657zM8 6a2 2 0 100 4 2 2 0 000-4zm2.844-2.998L9.503 4.838a3.514 3.514 0 011.659 1.659l1.836-1.341a5.778 5.778 0 00-2.154-2.154zM3.002 5.156l1.837 1.34a3.514 3.514 0 011.657-1.657l-1.34-1.837a5.778 5.778 0 00-2.154 2.154z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifebelt16);
export default __webpack_public_path__ + "static/media/lifebelt-16.a712dbb3.svg";
export { ForwardRef as ReactComponent };